import { round } from "lodash"

const task_utilities = {
    methods: {
        hours_per_week (hours) {
            const weeks = this.nb_weeks
            if(!weeks) return hours
            return round(hours / weeks, 1)
        },
        team_member_hours_per_week (task_id, user_id) {
            const hours = this.task_user_value(task_id, user_id, "hours") || 0
            return this.hours_per_week(hours)
        },
        save_team_member_hours_per_week (task_id, user_id, value, field) {
            this.save_task_user_field(task_id, user_id, parseFloat(value) * this.nb_weeks, field)
        },
        project_team_member_days_off (project_team_member) {
            const starts_at = this.record.starts_at
            const ends_at = this.record.ends_at
            if(!project_team_member || !starts_at || !ends_at) return 0
            const task_start = this.$moment(starts_at)
            const task_end = this.$moment(ends_at)
            return this.project_team_member_days_off_for_range(project_team_member, task_start, task_end)
        },
        change_dates (data) {
            if(data.starts_at) data.starts_at = this.$moment(data.starts_at).format("YYYY-MM-DD")
            if(data.ends_at) data.ends_at = this.$moment(data.ends_at).format("YYYY-MM-DD")
            this.save_data_for_record_id(this.entity, this.record_id, data)
            return data
        },
        clone_record () {
            this.$store.dispatch("RECORD_ACTION", {
                entity: "task",
                id: this.record.id,
                action: "clone",
                method: "post"
            }).catch(error => {
                this.$error(error.message)
            })
        },
        remove () {
            const category = this.record.milestone_id ? "Task" : "Milestone"
            let message = `Do you really want to delete the milestone ${this.record.description || ""}? This will also delete all tasks, subtasks  and time assignments.`
            if(!this.record.milestone_id) message = `Do you really want to delete the ${category.toLowerCase()} ${this.record.description || ""}? This will also all time assignments for it.`
            this.$confirm({
                type: "error",
                title: `Delete ${category}`,
                message,
                cancel: "Keep It",
                ok: "Delete It",
                then: (confirmed) => {
                    if(confirmed) {
                        this.$store.dispatch(
                            "RECORD_DELETE",
                            {
                                entity: "task",
                                id: this.record.id,
                                data: { relation_ids: ["project", "phase"] }
                            }
                        ).then(() => {
                        }).catch(error => {
                            this.$error(error.message)
                        })
                    }
                }
            })
        }
    },
    computed: {
        nb_weeks () {
            const task_starts_at = this.$moment(this.record.starts_at).startOf("isoWeek")
            const task_ends_at = this.record.completed_at || this.record.ends_at
            return this.$moment(task_ends_at).endOf("isoWeek").diff(task_starts_at, "weeks", true) || 1
        }
    }
}

export default task_utilities
